/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag jsx
 */

import { css, jsx } from '@compiled/react';

import { SmartCardProvider } from '@atlaskit/link-provider';

import { LinkListCompact } from './link-list-compact';
import { LinkListFull } from './link-list-full';
import type { LinkListSize, OnLinkClick } from './types';

interface LinkListProps {
	headerVisible?: boolean;
	maxSources?: number;
	onLinkClick?: OnLinkClick;
	/**
	 * Whether to show the show more/less expand button when the number of URLs
	 * exceeds `maxSources`. Defaults to `true`. Set to `false` to show all
	 * items up to `maxSources` with no expand/collapse toggle.
	 */
	showExpand?: boolean;
	size?: LinkListSize;
	urls: string[];
}

const containerRoot = css({
	width: '100%',
	containerType: 'inline-size',
	containerName: 'link-list-knowledge-card-container',
});

const showCompact = css({
	display: 'block',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries
	'@container link-list-knowledge-card-container (min-width: 481px)': {
		display: 'none',
	},
});

const showFull = css({
	display: 'none',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-container-queries
	'@container link-list-knowledge-card-container (min-width: 481px)': {
		display: 'block',
	},
});

export const DEFAULT_MAX_SOURCES = 4;

export const LinkList = ({
	urls,
	onLinkClick,
	size,
	maxSources,
	showExpand,
}: LinkListProps): JSX.Element => {
	return (
		<div css={containerRoot}>
			<SmartCardProvider>
				<div css={showCompact}>
					<LinkListCompact
						urls={urls}
						onLinkClick={onLinkClick}
						size={size}
						maxSources={maxSources}
						showExpand={showExpand}
					/>
				</div>
				<div css={showFull}>
					<LinkListFull
						urls={urls}
						onLinkClick={onLinkClick}
						maxSources={maxSources}
						showExpand={showExpand}
					/>
				</div>
			</SmartCardProvider>
		</div>
	);
};
